import { createTheme, darken } from '@material-ui/core/styles';
import createBreakpoints from '@material-ui/core/styles/createBreakpoints';
import fronts from './fonts';
import { HEADER_HEIGHT } from './sizes';

export const READER_THEMES = Object.freeze({
  light: 'light',
  sepia: 'sepia',
  dark: 'dark',
});

const createMuiTheme = ({ colors }) =>
  createTheme({
    palette: {
      primary: {
        main: colors.primaryColor,
      },
      background: {
        default: colors.backdropColor,
      },
      colors,
      authColors: {
        apple: {
          backgroundColor: '#FFFDFB',
          color: '#000',
        },
        facebook: {
          backgroundColor: '#4866B0',
          color: '#FFF',
        },
        google: {
          backgroundColor: '#518AFF',
          color: '#FFF',
        },
      }
    },
    reader: {
      highlightColor: '#FAFF00',
      colors: {
        highlightColors: {
          blue: '#86B5E1',
          yellow: '#FCEB23',
          green: '#B7D543',
          red: '#D982B7',
          purple: '#A26AB1',
        },
        [READER_THEMES.light]: {
          backdropOnColor: '#000000',
          backdropMutedColor: '#C1C1C1',
          backdropColor: '#FFFFFF',
          barColor: '#F9F9F9',
        },
        [READER_THEMES.sepia]: {
          backdropOnColor: '#121212',
          backdropMutedColor: '#FFFAF5',
          backdropColor: '#F3E7D1',
          barColor: '#E4D1C4',
        },
        [READER_THEMES.dark]: {
          backdropOnColor: '#FFFFFF',
          backdropMutedColor: '#FFFAF5',
          backdropColor: '#000000',
          barColor: '#202020',
        },
      },
    },
    videoPlayer: {
      colors: {
        videoBackdropColor: '#000',
        videoBackdropOnColor: '#FFF',
        videoSurfaceColor: '#FFF',
        videoSurfaceOnColor: '#000',
        videoSurfaceMutedColor: '#eee',
      },
    },
    typography: {
      fontFamily: 'ARSMaquetteProMedium',
    },
    overrides: {
      MuiCssBaseline: {
        '@global': {
          '@font-face': fronts,
        },
      },
      MuiAppBar: {
        root: {
          height: HEADER_HEIGHT,
          boxShadow: 'none',
          zIndex: 1,
        },
        colorPrimary: {
          backgroundColor: 'inherit',
        },
      },
      MuiTypography: {
        h2: {
          fontSize: 24,
          lineHeight: '18px',
          color: colors.backdropOnColor,
        },
        h3: {
          fontSize: 14,
          lineHeight: '22px',
          letterSpacing: '0.5px',
          color: colors.backdropOnColor,
        },
      },
      MuiLink: {
        root: {
          cursor: 'pointer',
        },
      },
      MuiButton: {
        textSecondary: {
          color: colors.backdropOnColor,
          padding: 0,
          minWidth: 22,
          backgroundColor: colors.backdropColor,
        },
        root: {
          textTransform: 'none',
        },
        contained: {
          color: colors.primaryOnColor,
          backgroundColor: colors.primaryColor,
          '@media (hover: hover)': {
            '&:hover': {
              backgroundColor: darken(colors.primaryColor, 0.1),
            },
          },
          '&$disabled': {
            color: colors.primaryOnColor,
            backgroundColor: colors.primaryMutedColor,
          },
        },
      },
      MuiFormLabel: {
        root: {
          fontSize: '14px',
          lineHeight: '22px',
        },
      },
      MuiInputLabel: {
        shrink: {
          transform: 'translate(0, -5px)',
        },
      },
      MuiDivider: {
        root: {
          backgroundColor: colors.surfaceMutedColor,
        },
      },
      MuiSlider: {
        rail: {
          color: colors.surfaceMutedColor,
        },
        valueLabel: {
          zIndex: 20,
          left: 'calc(-50% - -1px)',
        },
      },
      MuiIconButton: {
        root: {
          borderRadius: 'unset',
          '@media (hover: hover)': {
            '&:hover': {
              backgroundColor: 'transparent',
            },
          },
        },
      },
    },
    breakpoints: createBreakpoints({
      values: {
        mobile: 0,
        tablet: 640,
        laptop: 991,
        desktop: 1024,
        mobileFullPlayer: 780,
        trackPageMobile: 700,
      },
    }),
  });

export default createMuiTheme;
